/*************************************************/
/* IE-Fixes                                        */
/*************************************************/

export function ieFixes() {
    var isIe = false;
    const init = function () {
        var i = window && window.navigator.userAgent;
        isIe = (-1 !== i.indexOf("MSIE") || -1 !== i.indexOf("Trident/7.0"));

        if (isIe) {
            disableTransitions();
        }
    }

    function disableTransitions() {
        var noTransitionClass = "notransition";
        var links = document.getElementsByClassName("menu-nav__link");
        for (var i = 0; i < links.length; i++) {
            links[i].classList.add(noTransitionClass);
        }
    }

    init();
};
